var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16.0 18.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,3383 L0,3383 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5270842,0 C14.127,0 15.4285714,1.32151795 15.4285714,2.94612121 C15.4285714,4.5707245 14.127,5.89237977 12.5270842,5.89237977 C11.6777628,5.89237977 10.9125621,5.51980589 10.3814658,4.92736816 L5.60457419,7.93171691 C5.73210764,8.26309202 5.80283935,8.62316895 5.80283935,9 C5.80283935,9.37669373 5.73210764,9.73677062 5.60457419,10.0682831 L10.3814658,13.0724945 C10.9125621,12.4800568 11.6777628,12.1076202 12.5270842,12.1076202 C14.127,12.1076202 15.4285714,13.4292755 15.4285714,15.0538788 C15.4285714,16.6783447 14.127,18 12.5270842,18 C10.9271683,18 9.62559685,16.6783447 9.62559685,15.0538788 C9.62559685,14.6770477 9.69646379,14.3169708 9.82386201,13.9854584 L5.04710564,10.981247 C4.5160093,11.573822 3.75080866,11.9462586 2.90148731,11.9462586 C1.30157144,11.9462586 0,10.6246033 0,9 C0,7.37553407 1.30157144,6.05374144 2.90148731,6.05374144 C3.75080866,6.05374144 4.5160093,6.42631532 5.04710564,7.01875304 L9.82386201,4.01454162 C9.69646379,3.68302918 9.62559685,3.32295226 9.62559685,2.94625856 C9.62559685,1.32165527 10.9271683,0 12.5270842,0 Z M12.5270842,13.1818085 C11.5106034,13.1818085 10.683597,14.0215759 10.683597,15.0537414 C10.683597,16.085907 11.5106034,16.9256744 12.5270842,16.9256744 C13.5435649,16.9256744 14.3705713,16.085907 14.3705713,15.0537414 C14.3705713,14.0215759 13.5435649,13.1818085 12.5270842,13.1818085 Z M2.90148731,7.12806701 C1.88487127,7.12806701 1.05786492,7.96783447 1.05786492,9 C1.05786492,10.0321655 1.88487127,10.871933 2.90148731,10.871933 C3.91796805,10.871933 4.7448392,10.0321655 4.7448392,9 C4.7448392,7.96783447 3.91796805,7.12806701 2.90148731,7.12806701 Z M12.5270842,1.07432557 C11.5106034,1.07432557 10.683597,1.914093 10.683597,2.94625856 C10.683597,3.97842405 11.5106034,4.81819152 12.5270842,4.81819152 C13.5435649,4.81819152 14.3705713,3.97842405 14.3705713,2.94625856 C14.3705713,1.914093 13.5435649,1.07432557 12.5270842,1.07432557 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1240.0 -997.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 500.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.0 100.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 361.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(690.0000000000002 36.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.4285714,0 15.4285714,18 0,18 0,0",
    stroke: "none",
    fill: "#FF5043"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b2f755ea1724939f7a22cd55cfb730be.svg";
export { ForwardRef as ReactComponent };